module.exports = __webpack_public_path__ + "img/slipmat-a-trans.f51ac2d7.png";